// DS: IL3.8
import React from 'react';

export const Leave: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="90" height="88">
      <defs>
        <linearGradient id="leave-il-a" x1="86.44%" x2="86.44%" y1="100%" y2="40.149%">
          <stop offset="0%" stopColor="#00D38F" stopOpacity="0"></stop>
          <stop offset="100%" stopColor="#00D38F"></stop>
        </linearGradient>
        <linearGradient id="leave-il-b" x1="20.527%" x2="81.894%" y1="12.984%" y2="68.902%">
          <stop offset="0%" stopColor="#FFF"></stop>
          <stop offset="100%" stopColor="#C2C2C2"></stop>
        </linearGradient>
        <linearGradient id="leave-il-c" x1="77.21%" x2="50%" y1="76.025%" y2="23.975%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0"></stop>
          <stop offset="100%" stopColor="#FFF"></stop>
        </linearGradient>
        <linearGradient id="leave-il-d" x1="34.923%" x2="50%" y1="32.032%" y2="50%">
          <stop offset="0%" stopColor="#FFF"></stop>
          <stop offset="100%" stopColor="#9A9EA1"></stop>
        </linearGradient>
        <linearGradient id="leave-il-e" x1="7.518%" x2="75.309%" y1="44.143%" y2="61.409%">
          <stop offset="0%" stopColor="#161A1F" stopOpacity="0"></stop>
          <stop offset="24.853%" stopColor="#161A1F" stopOpacity="0"></stop>
          <stop offset="100%" stopColor="#161A1F"></stop>
        </linearGradient>
      </defs>
      <g fill="none">
        <path fill="url(#leave-il-a)" d="M45.14 38.95L17.95 83.37h25.52z"></path>
        <path fill="#292F34" d="M51.75 57.84l-21.09-5.66-3.06-8.59 31.1 8.33z"></path>
        <path
          fill="url(#leave-il-b)"
          d="M67.91 31l-1.7 6.32L27.6 26.97l2.49-6.1 4.32-8 6.37-4.71 6.42-1.73 6.86.59L60.1 9.8l4.61 4.46 3.46 7.7z"
        ></path>
        <path
          fill="url(#leave-il-c)"
          d="M52.68 15.06l-4.13-5.97-8.05 2.16-4.37 7.98 7.08 1.8z"
        ></path>
        <path
          fill="url(#leave-il-d)"
          d="M27.68 22.81l20.36 5.52 20.4 5.41-.04.11 1.73 4.11 15.91 9.72-11.79 5.95-15.04-.11-33.43-8.96-13.08-7.42-6.66-10.89 18.06-.62 3.55-2.7.03-.12z"
        ></path>
        <path
          fill="url(#leave-il-e)"
          d="M6.04 26.25l6.66 10.89 13.08 7.42 33.43 8.96 15.04.11 11.79-5.95z"
        ></path>
        <path
          fill="#FFF"
          d="M29.84 30.77l.56 2.91-2.24 1.94-2.8-.97-.56-2.91 2.24-1.95zm16.99 4.61l.56 2.91-2.24 1.94-2.8-.97-.56-2.91 2.24-1.94zm16.91 4.85l.56 2.91-2.24 1.94-2.8-.97-.56-2.91 2.24-1.94z"
        ></path>
      </g>
    </svg>
  );
};
Leave.displayName = 'Leave';
